import { defineConstants } from "@p-ban/common/src/constants/defineConstants"

const COGNITIVE_MEDIA = defineConstants([
  { label: "Quadceptメルマガ", value: "QuadceptEmailMagazine", isOther: false },
  { label: "Quadceptホームページバナー", value: "QuadceptHomepageBanner", isOther: false },
  { label: "P板.comメルマガ", value: "PbanEmailMagazine", isOther: false },
  { label: "P板.comホームページバナー", value: "PbanHomepageBanner", isOther: false },
  { label: "インターネット検索", value: "WebSearch", isOther: false },
  { label: "Twitter", value: "Twitter", isOther: false },
  { label: "Facebook", value: "Facebook", isOther: false },
  { label: "基板のふるさと", value: "SubstrateHome", isOther: false },
  { label: "知人の紹介", value: "Acquaintance", isOther: false },
  { label: "ニュースサイト", value: "NewsSite", isOther: false },
  { label: "その他", value: "Other", isOther: true },
] as const)

export default COGNITIVE_MEDIA
